module.exports = ".lui-showmore__seed{cursor:pointer;display:inline-block}:host([left]) .lui-showmore__seed{transform:scaleX(-1)}:host([disabled]) .lui-showmore__seed{pointer-events:none}.lui-showmore__pill{fill:var(--lui-secondary-background-color)}:host([disabled]) .lui-showmore__pill{fill:var(--lui-tertiary-background-color)}.lui-showmore__dots{fill:var(--lui-neutral-color)}:host([disabled]) .lui-showmore__dots{fill:var(--lui-background-color)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-showmore/theme/lui-showmore.scss
// module id = 311
// module chunks = 0 1 38